// extracted by mini-css-extract-plugin
export default {"productGallery":"UO-z","inQuickShop":"VO-z"};